import { MedicalRecordReportFormData } from '@/modules/Telemedicine/pages/MedicalRecord/MedicalRecordReport/MedicalRecordReport.types'
import { format } from 'date-fns'

class MedicalRecordReportDownloadMapper {
  toPersistence(data: MedicalRecordReportFormData) {
    return {
      patientId: data?.patient?.patientId,
      professionalId: data?.professional?.id,
      startDate: format(data?.initialDate, 'yyyy-MM-dd'),
      endDate: format(data?.finalDate, 'yyyy-MM-dd'),
      isPatientPViva: data?.isPatientPViva,
    }
  }
}

export default new MedicalRecordReportDownloadMapper()
